<div class="dialog-header">
  <h2 mat-dialog-title>Set Up Box Webhook</h2>
  <button mat-icon-button (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="webhook-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Box Connection</mat-label>
      <mat-select formControlName="connectionId">
        @for (conn of boxConnections(); track conn.connectionId) {
          <mat-option [value]="conn.connectionId">{{ conn.name }}</mat-option>
        }
      </mat-select>
      @if (boxConnections().length === 0) {
        <mat-hint>No Box connections in this project.</mat-hint>
      }
    </mat-form-field>

    <!-- Readiness gating -->
    @if (loadingReadiness()) {
      <div class="readiness readiness--checking">
        <mat-spinner diameter="18"></mat-spinner>
        <span>Checking webhook readiness…</span>
      </div>
    } @else if (readiness(); as r) {
      @if (r.ready) {
        <div class="readiness readiness--ok">
          <mat-icon>check_circle</mat-icon>
          <span>This connection can provision webhooks.</span>
        </div>
      } @else {
        <div class="readiness readiness--blocked">
          <mat-icon>error</mat-icon>
          <div>
            <strong>Webhook setup is not available for this connection:</strong>
            <ul>
              @for (reason of r.reasons; track reason) {
                <li>{{ reason }}</li>
              }
            </ul>
          </div>
        </div>
      }
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Box Folder ID</mat-label>
      <input
        matInput
        formControlName="folderId"
        autocomplete="off"
        spellcheck="false"
      />
      <mat-hint>The folder to watch for the selected triggers.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Triggers</mat-label>
      <mat-select formControlName="triggers" [multiple]="true">
        @for (trigger of triggers; track trigger) {
          <mat-option [value]="trigger">{{ trigger }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>

  <!-- This project's webhooks provisioned through the selected connection -->
  @if (existingWebhooks().length > 0) {
    <div class="existing">
      <h3>Existing webhooks for this project</h3>
      <ul class="webhook-list">
        @for (wh of existingWebhooks(); track wh.id) {
          <li>
            <span class="webhook-meta">
              #{{ wh.id }}
              @if (wh.folderPath) {
                · {{ wh.folderPath }}
                @if (wh.target?.id; as targetId) {
                  (folder {{ targetId }})
                }
              } @else if (wh.target?.id; as targetId) {
                · folder {{ targetId }}
              }
              @if (wh.triggers?.length) {
                · {{ wh.triggers.join(", ") }}
              }
            </span>
            <button
              mat-icon-button
              color="warn"
              (click)="deleteWebhook(wh)"
              aria-label="Delete webhook"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!canProvision()"
    (click)="provision()"
  >
    @if (provisioning()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      Provision Webhook
    }
  </button>
</mat-dialog-actions>
